import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Configuration } from './configuration/configurations';
import { UserService, AlertService, PushNotificationsService } from './_services';
import { UnallocatecalllogComponent } from './unallocatecalllog/unallocatecalllog.component';
import { User } from './_models';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { interval, Subscription } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [Configuration]

})
export class AppComponent {
  title = 'app';
  public pathString: string;
  public showSidebar = false;
  private themeWrapper = document.querySelector('body');
  private subhostname: any;
  private siteUrl: any = "";
  private dnsname: string = "";
  public ClientLogo: string = "";
  subscription: Subscription;
  intervalId: number;
  //@ViewChild(UnallocatecalllogComponent) child: UnallocatecalllogComponent;
  constructor(private _notificationService: PushNotificationsService, private alertService: AlertService, private location: Location, private route: ActivatedRoute, private _configuration: Configuration, private userservice: UserService) {
    //this._notificationService.requestPermission();
  }

  ngOnInit() {
    this.pathString = this.location.path().split("?")[0];
    let queydata = this.GetParam('authdata');
    console.log('queydata', queydata);

    // this.route.snapshot.queryParams.subscribe(params => {
    //   const authdata = params['authdata'];
    //   console.log('authdata', authdata);
    if (queydata !== '') {
      debugger;
      let testdata = atob(queydata);
      console.log("testdata", testdata);
      let response = JSON.parse(testdata);
      console.log("jsondata", response);
      localStorage.removeItem("PrimaryColor")
      this.themeWrapper.style.removeProperty('--colorPrimary');
      localStorage.removeItem("SecondaryColor")
      this.themeWrapper.style.removeProperty('--colorSecondary');
      localStorage.removeItem("clientLogo");
      localStorage.setItem('currentUser', JSON.stringify(response));

      let access_token = response['access_token'];
      let token_type = response['token_type'];
      let expires_in = response['expires_in'];
      let role = response['roleName'];
      let user = response['User'];
      let username = response['UserName'];
      let displayname = response['DisplayName'];
      let clientcode = response['ClientCode'];
      let ClientName = response["ClientName"];
      let rate = response['Rate'];
      let Extensions = response["Extensions"];
      let ServerId = response["ServerID"];
      let clientlogo = response["Logo"];
      let clientPrimaryColor = response["PrimaryColor"];
      let clientSecondaryColor = response["SecondaryColor"];
      let dnsName = response["DnsName"];
      let TaskEnabled = 'N';
      if (response["TaskEnabled"] != undefined && response["TaskEnabled"] != '' && response["TaskEnabled"] != null) {
        TaskEnabled = response["TaskEnabled"];
      }
      console.log("Client Primary Color", clientPrimaryColor)
      console.log("Client Secondary Color", clientSecondaryColor)
      localStorage.setItem("Authorization", JSON.stringify(token_type + ' ' + access_token));
      localStorage.setItem("role", role);
      localStorage.setItem("user", user);
      localStorage.setItem("userName", username);
      localStorage.setItem("displayName", displayname);
      localStorage.setItem("clientcode", clientcode);
      localStorage.setItem("rate", rate);
      localStorage.setItem("Extensions", Extensions);
      localStorage.setItem("ClientName", ClientName);
      localStorage.setItem("ServerId", ServerId)
      localStorage.setItem("TaskEnabled", TaskEnabled)
      if (clientPrimaryColor) {
        localStorage.setItem("PrimaryColor", clientPrimaryColor)
        this.themeWrapper.style.setProperty('--colorPrimary', clientPrimaryColor);
      }
      if (clientSecondaryColor) {
        localStorage.setItem("SecondaryColor", clientSecondaryColor)
        this.themeWrapper.style.setProperty('--colorSecondary', clientSecondaryColor);
      }
      if (clientlogo) {
        localStorage.setItem("clientLogo", clientlogo);
      }

      localStorage.setItem("clientPrimaryColor", clientPrimaryColor);
      localStorage.setItem("clientSecondaryColor", clientSecondaryColor);

      if (dnsName != "") {
        localStorage.setItem("isfromDns", "true");
        localStorage.setItem("DnsName", dnsName);
        let urlwithdns = this._configuration.baseUrlToken;
        urlwithdns = urlwithdns.replace("www", dnsName);
        localStorage.setItem("ReselerUrl", urlwithdns);
      }
      //     this._router.navigateByUrl('/sidebar', { skipLocationChange: true }).then(() =>
      //     this._router.navigate(['/dashboard'])
      // );
    }

    // if(this._configuration._local)
    // {
    //   this.siteUrl=new URL(this._configuration._subdomainhost);
    // }
    // else
    // {
    //   this.siteUrl=window.location;

    // }
    // this.subhostname= this.siteUrl.host;
    // let idx = this.subhostname.indexOf('.com');
    // let sec = this.subhostname.substring(0, idx - 1).lastIndexOf('.');
    // var rootDomain = this.subhostname.substring(sec + 1);
    // this.subhostname = this.subhostname.replace(rootDomain, "");
    // this.subhostname = this.subhostname.replace(".", "");
    // if(this.subhostname != "")
    // {
    //   this.userservice.GetClientDetailByDns(this.subhostname)
    //   .pipe(first()).subscribe(
    //       response => {
    //           let data=response["Data"];

    //                if(response["StatusCode"]=="200")
    //                {
    //                   console.log("Cleitn Data",data["Data"]);
    //                   this.themeWrapper.style.setProperty('--bgPrimary',data["PrimaryColor"] );
    //                }
    //               },
    //                error => {
    //               //         this.alertService.showNotification('error',"Some thing went wrong.")
    //                 //       this.loading = false;
    //                }
    //                );
    // }
    if (localStorage.getItem('currentUser')) {
      // This is METHOD 1
      const source = interval(3000);
      this.subscription = source.subscribe(val => this.LatestUnAllocatedCall());
    }
    else {
      this.subscription && this.subscription.unsubscribe();
    }
    if (localStorage.getItem("PrimaryColor")) {
      let pcolor = localStorage.getItem("PrimaryColor");
      this.themeWrapper.style.setProperty('--colorPrimary', pcolor);
    }
    if (localStorage.getItem("SecondaryColor")) {
      let scolor = localStorage.getItem("SecondaryColor");
      this.themeWrapper.style.setProperty('--colorSecondary', scolor);
    }
    if (localStorage.getItem("BodyBackGround")) {
      this.themeWrapper.classList.add("bodybackground");
    }
    if (localStorage.getItem("clientLogo")) {
      this.ClientLogo = localStorage.getItem("clientLogo");
    }
    if (this.pathString != "/login" && this.pathString != "//login" && this.pathString != "/resetpassword" && this.pathString != "//resetpassword" && this.pathString != "/changepassword" && this.pathString != "//changepassword") {
      this.showSidebar = true;
    }
    else {
      this.showSidebar = false;
    }
    if (this.pathString == "") {
      this.showSidebar = false;
      //let redirecturl:string=this._configuration.baseUrlToken;
      if (this._configuration._local) {
        this.siteUrl = new URL(this._configuration._subdomainhost);
      }
      else {
        this.siteUrl = window.location;

      }
      // this.subhostname= this.siteUrl.host;
      // let idx = this.subhostname.indexOf('.it');
      // let sec = this.subhostname.substring(0, idx - 1).lastIndexOf('.');
      // var rootDomain = this.subhostname.substring(sec + 1);
      // this.subhostname = this.subhostname.replace(rootDomain, "");
      // this.subhostname = this.subhostname.replace(".", "");
      // if(this.subhostname != "")
      // {
      //   this.userservice.GetClientDetailByDns(this.subhostname)
      //   .pipe(first()).subscribe(
      //     response => {
      //         let data=response["Data"];

      //              if(response["StatusCode"]=="200")
      //              {
      //                 //redirecturl=this.siteUrl.origin;
      //                 window.location.href=this.siteUrl.origin+"/login";
      //              }
      //              else
      //              {
      //               window.location.href=this._configuration.baseUrlToken+"/login";
      //              }
      //              },
      //                error => {
      //               //         this.alertService.showNotification('error',"Some thing went wrong.")
      //                 //       this.loading = false;
      //                 window.location.href=this._configuration.baseUrlToken+"/login";
      //                }
      //                );
      // }
      window.location.href = this._configuration.baseUrlToken + "/login";
      //window.location.href = 'http://localhost:4200' + "/login";

    }


    console.log(this._configuration.baseUrlToken);

  }
  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return '';
    }
    return results[1] || '';
  }
  LatestUnAllocatedCall() {
    // I've just commented this so that you're not bombarded with an alert.
    // alert(text);
    this.userservice.GetLatestUnallotedCallLog(localStorage.getItem("user"), parseInt(localStorage.getItem("UnAllocateCallCount"))).subscribe(
      response => {
        let data = response;
        if (data["StatusCode"] == "200") {
          let CallList = data["Data"];
          //this.alertService.showNotification('error',CallList["Call"].length + "Record In UnAllocate.")
          if (CallList["Call"].length > 0) {
            let pushdata: Array<any> = [];
            pushdata.push({
              'title': '',
              'alertContent': CallList["Call"].length + " New unallocated call received."
            });
            this._notificationService.generateNotification(pushdata);
            let tempcount = 0;
            if (localStorage.getItem("UnAllocateCallCount") != "NaN" && localStorage.getItem("UnAllocateCallCount")) {
              tempcount = parseInt(localStorage.getItem("UnAllocateCallCount"));
            }
            let totalcount = tempcount + CallList["Call"].length;
            localStorage.setItem("UnAllocateCallCount", totalcount)
            sessionStorage.setItem("UnAllocateCallCount", totalcount)
            document.title = "Revoco";
            let tital = document.title;
            let newTitle = '(' + totalcount + ') ' + tital;
            document.title = newTitle;
            let faviconlink = document.getElementById('fevicon');
            faviconlink.setAttribute("href", "assets/images/favicon-dot.png");
          }
        }
        else {
          // this.gridOptions.api.hideOverlay();
        }


      },
      error => {
        // this.alertService.showNotification('error', "Some thing went wrong.")

      })
  }


}
